import { ReportAllocatedAndSubsidies39Container } from "../../../containers/SupportSystem/Reports/ReportAllocatedAndSubsidies39Container";
export function ReportAllocatedAndSubsidies39Page() {
    return (
        <ReportAllocatedAndSubsidies39Container/>
    );

}